/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GetChainExecutionUsageRequest {
    chainExecutionId: string;
    breakdown?: boolean;
    sessionId?: string;
}

export interface ListChainExecutionsRequest {
    instanceId?: string;
    page?: number;
    pageSize?: number;
    sessionId?: string;
}

export interface SignalChainWorkflowRequest {
    chainExecutionId: string;
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

/**
 * IntegrationMarketplaceChainExecutionsApi - interface
 * 
 * @export
 * @interface IntegrationMarketplaceChainExecutionsApiInterface
 */
export interface IntegrationMarketplaceChainExecutionsApiInterface {
    /**
     * Rolled-up usage (metering) for the chain run. Use breakdown=true for per-step usage.
     * @summary Get chain execution usage
     * @param {string} chainExecutionId Chain execution ID
     * @param {boolean} [breakdown] Include per-step usage breakdown
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceChainExecutionsApiInterface
     */
    getChainExecutionUsageRaw(requestParameters: GetChainExecutionUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Rolled-up usage (metering) for the chain run. Use breakdown=true for per-step usage.
     * Get chain execution usage
     */
    getChainExecutionUsage(requestParameters: GetChainExecutionUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * List all runs for selected tenants (single-step and multi-step). Optional instance filter. Uses page/pageSize pagination.
     * @summary List chain executions
     * @param {string} [instanceId] Filter by instance ID (only runs that include this instance)
     * @param {number} [page] Page number (1-based)
     * @param {number} [pageSize] Page size
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceChainExecutionsApiInterface
     */
    listChainExecutionsRaw(requestParameters: ListChainExecutionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * List all runs for selected tenants (single-step and multi-step). Optional instance filter. Uses page/pageSize pagination.
     * List chain executions
     */
    listChainExecutions(requestParameters: ListChainExecutionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Send a signal to a running chain workflow (e.g. Approval with payload { \"approved\": true })
     * @summary Signal chain workflow
     * @param {string} chainExecutionId Chain execution ID
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceChainExecutionsApiInterface
     */
    signalChainWorkflowRaw(requestParameters: SignalChainWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Send a signal to a running chain workflow (e.g. Approval with payload { \"approved\": true })
     * Signal chain workflow
     */
    signalChainWorkflow(requestParameters: SignalChainWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class IntegrationMarketplaceChainExecutionsApi extends runtime.BaseAPI implements IntegrationMarketplaceChainExecutionsApiInterface {

    /**
     * Rolled-up usage (metering) for the chain run. Use breakdown=true for per-step usage.
     * Get chain execution usage
     */
    async getChainExecutionUsageRaw(requestParameters: GetChainExecutionUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['chainExecutionId'] == null) {
            throw new runtime.RequiredError(
                'chainExecutionId',
                'Required parameter "chainExecutionId" was null or undefined when calling getChainExecutionUsage().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['breakdown'] != null) {
            queryParameters['breakdown'] = requestParameters['breakdown'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/chain-executions/{chainExecutionId}/usage`;
        urlPath = urlPath.replace(`{${"chainExecutionId"}}`, encodeURIComponent(String(requestParameters['chainExecutionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Rolled-up usage (metering) for the chain run. Use breakdown=true for per-step usage.
     * Get chain execution usage
     */
    async getChainExecutionUsage(requestParameters: GetChainExecutionUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getChainExecutionUsageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all runs for selected tenants (single-step and multi-step). Optional instance filter. Uses page/pageSize pagination.
     * List chain executions
     */
    async listChainExecutionsRaw(requestParameters: ListChainExecutionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['instanceId'] != null) {
            queryParameters['instanceId'] = requestParameters['instanceId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/chain-executions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * List all runs for selected tenants (single-step and multi-step). Optional instance filter. Uses page/pageSize pagination.
     * List chain executions
     */
    async listChainExecutions(requestParameters: ListChainExecutionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listChainExecutionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send a signal to a running chain workflow (e.g. Approval with payload { \"approved\": true })
     * Signal chain workflow
     */
    async signalChainWorkflowRaw(requestParameters: SignalChainWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['chainExecutionId'] == null) {
            throw new runtime.RequiredError(
                'chainExecutionId',
                'Required parameter "chainExecutionId" was null or undefined when calling signalChainWorkflow().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling signalChainWorkflow().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/marketplace/chain-executions/{chainExecutionId}/signal`;
        urlPath = urlPath.replace(`{${"chainExecutionId"}}`, encodeURIComponent(String(requestParameters['chainExecutionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Send a signal to a running chain workflow (e.g. Approval with payload { \"approved\": true })
     * Signal chain workflow
     */
    async signalChainWorkflow(requestParameters: SignalChainWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.signalChainWorkflowRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
